import { useEffect, useRef } from 'react';
import { gql, useMutation } from '@apollo/client';
import { useCustomer } from './useCustomer';
import { clearStoredReferralCode, getStoredReferralCode } from './useReferralCode';

const RECORD_REFERRAL = gql`
  mutation recordReferralMutation($referralCode: String!) {
    recordReferral(referralCode: $referralCode)
  }
`;

export function useReferralAttribution() {
  const { customer } = useCustomer();
  const [recordReferral] = useMutation(RECORD_REFERRAL);
  const attempted = useRef(false);

  useEffect(() => {
    if (!customer?.id || attempted.current) return;

    const code = getStoredReferralCode();
    if (!code) return;

    attempted.current = true;

    recordReferral({ variables: { referralCode: code } })
      .then(() => clearStoredReferralCode())
      .catch(() => {});
  }, [customer?.id]);
}
